var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8907 15.3631L11.4227 10.8951C12.4944 9.69875 13.0864 8.14872 13.0851 6.54257C13.0851 2.93499 10.1502 0 6.54257 0C2.93499 0 0 2.93499 0 6.54257C0 10.1502 2.93499 13.0851 6.54257 13.0851C8.14872 13.0864 9.69875 12.4944 10.8951 11.4227L15.3631 15.8907C15.5088 16.0364 15.745 16.0364 15.8907 15.8907C16.0364 15.745 16.0364 15.5088 15.8907 15.3631L15.8907 15.3631ZM0.746114 6.54257C0.746114 3.34639 3.34639 0.746114 6.54257 0.746114C9.73873 0.746114 12.339 3.34639 12.339 6.54257C12.339 9.73873 9.73873 12.339 6.54257 12.339C3.34639 12.339 0.746114 9.73873 0.746114 6.54257Z",
    id: "Shape",
    fill: "#666666",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGrey);
export default __webpack_public_path__ + "static/media/search-grey.f06d087850a86bc43b860625e7714f8f.svg";
export { ForwardRef as ReactComponent };